import React, { Component } from 'react';
import  * as actionCreators  from '../../store/actions/login';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Spinner from '../Spinner/Spinner';
import AddAcount from '../AddAccount/AddAcount';
import DataGrid from '../../datagrid/DataGrid';
import { Button } from 'react-bootstrap';
import { api } from '../../api/client';


class LinkedAccounts extends Component {

    constructor(props) {
        super(props);
        var me = this;
        me.onAccountDialogClose = me.onAccountDialogClose.bind(me);
        me.rowClick = me.rowClick.bind(me);
        me.state = {
            loading: false,
            dataLoaded: false,
            serverError: '',
            Id: '',
            success: false,
            accounts: [],
            redirect: false,
            showAccountModal: false,
            total: 0
        };
    }

    async componentDidMount() {
        if (this.props.location.pathname.indexOf("add") > 0) {
            this.setState({ showAccountModal: true });
        }
        await this.loadAccounts();
    }

    async loadAccounts() {
        const me = this;
        const currentAccountNumber = this.props.currentAccount?this.props.currentAccount.value:null;
        try {
            const userId = me.props.CurrentUser.userId;
            me.setState({ loading: true, dataLoaded: false });
            var url = 'users/' + userId + '/accounts';
            const response = await api.get(url);
            const responseData = response.data;
            const accounts = responseData.map(f => ({ AccountNumber: f.Account.AccountNumber, Name: f.Account.Name, StartDate: f.StartDate }));
           // debugger;

            //if it is first added account select it in Redux
            if(accounts && accounts.length > 0 && !currentAccountNumber){                    
                const acc = accounts.map(a=>({value:a.AccountNumber}));
                this.props.accountSelected(acc[0]);                
            }

            // console.log(`${accounts}`);
            me.setState({ accounts, total: accounts.length });
            me.setState({ loading: false, dataLoaded:true });
        }
        catch (error) {
            const errorMessage = error.message ? error.message : 'Something went wrong';
            me.setState({ serverError: errorMessage, loading: false, dataLoaded: true });
            console.log(error);
        }
    }

    onAccountDialogClose(){        
        this.setState({ showAccountModal: false });
        
        this.props.history.push("/profile/linkedaccounts");
        this.loadAccounts();
    }

    addAccountClick() {
        this.props.history.push("/profile/linkedaccounts/add");
        this.setState({showAccountModal:true});
    }

    buttonFormatter({row}) {     
        return <Button
            onClick={()=>this.rowClick(row)}
            bsStyle="info" bsSize="small">
            Go to Account Details</Button>;
    }

    rowClick({AccountNumber}) {        
        this.props.history.push(`/accounts/${AccountNumber}`);
    }

    render() {
        const me = this;
        const accountModal = me.state.showAccountModal? 
               
        <AddAcount  onClose={this.onAccountDialogClose}></AddAcount>:null;
        const serverError = me.state.serverError !== ''
            ? <div
                className='errorMessage'
                style={{
                    marginBottom: 10,
                    padding: '1rem',
                }}>{me.state.serverError}
            </div>
            : null;

        const spinner = me.state.loading
            ? <Spinner />
            : null;

        const defaultColumnProperties = {
            resizable: true
        };

        const columns = [
            { key: 'AccountNumber', name: 'Account Number', width: 180 },
            { key: 'Name', name: 'Account Name'},
            {
                key: 'ActionColumn',
                name: ' ',
                width: 180,
                resizable: true,
                filterable: false,
                formatter: me.buttonFormatter.bind(me)
            }
        ].map(c => ({ ...c, ...defaultColumnProperties }));

        let linkedAccountsGrid = <div>
            
            <DataGrid {...me.props}
                columns={columns}
                rowGetter={i => me.state.accounts[i]}
                rowsCount={me.state.total}
                mobileLayoutOnResize
                hideToolbar
            />
        </div>;
        let noDataMessage =<h4>You have no linked accounts,
                    please click the &apos;Add Account&apos;
                    button below to link a new account.</h4>;

        return (
            <React.Fragment>
                {me.state.accounts.length === 0 && me.state.dataLoaded ?
                    <div>{noDataMessage}</div>
                    : <div> {linkedAccountsGrid}</div>
                }
                {serverError}
                {spinner}
                {accountModal}

                <div className="button-group">
                    <Button type="submit"
                        onClick={(e) => this.addAccountClick(e)}
                        bsStyle="primary">
                        Add Account</Button>
                </div>

           </React.Fragment>
        );
    }
}

export default connect(state => ({...state.login, currentAccount: state.account.account }), dispatch => bindActionCreators(actionCreators, dispatch))(LinkedAccounts);